import util from '../util'

const controller = 'ContaVinculada'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
    BuscarPorCodigoConta: function(codigo, tipoVinculoConta) {
        return util.Axios.Get(controller + `/${codigo}?tipoVinculoConta=${tipoVinculoConta}`)
    },
    VinculosPorConta: function(codigo) {
        return util.Axios.Get(controller + `/${codigo}/VinculosPorConta`)
    },
    EditarContaVinculada: function (codigo, dto) {
        return util.Axios.Put(`${controller}`, codigo, dto)
    }
})